var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5398",
    "data-name": "Group 5398",
    transform: "translate(-1745 -516)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1745 516)",
    fill: "rgba(221, 221, 221, 0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M16,7a1.5,1.5,0,0,0-1.5,1.5v9.536a1.5,1.5,0,1,0,3,0V8.5A1.5,1.5,0,0,0,16,7Zm0,13.911a1.5,1.5,0,0,0-1.5,1.5V23.5a1.5,1.5,0,0,0,3,0V22.411A1.5,1.5,0,0,0,16,20.911Z",
    transform: "translate(1749.5 520)",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconHover);
export default __webpack_public_path__ + "static/media/infoIconHover.1ffdcab65738688537c908117ff8ee3c.svg";
export { ForwardRef as ReactComponent };